const SVG = '.svg';
const PNG = '.png';
const ASSETS_DATA_PATH = './assets/data/';
const ASSESTS = 'assets/';
const DEFAULT_COL_DEF = {
    resizable: true,
    flex: 1,
    minWidth: 150,
    filter: true,
    enableRangeSelection: true,
    pagination: true,
    paginationPageSize: 10,
};

export {
    SVG,
    PNG,
    ASSESTS,
    ASSETS_DATA_PATH,
    DEFAULT_COL_DEF
};
